// EmailVerifierMsgs is an object containing objects indicating return status
// returned from the email verification function that is mixed into main.
export const EmailVerifierMsgs = {
  SuccessInQReserve: {
    msg: 'User found in QReserve.',
    typ: 'success',
  },
  SuccessInSite: {
    msg: 'User found in this QReserve site.',
    typ: 'success',
  },
  WarnNotInQreserve: {
    msg: 'User will receive an email to join QReserve.',
    typ: 'warn',
  },
  Failure: {
    msg: 'Please select a site user or enter an email.',
    typ: 'fail',
  },
  NetworkFailure: {
    msg: 'Unknown response received from QReserve servers.',
    typ: 'fail',
  },
};

// ConvertXMLRequestError converts an XML request error from axios into a
// simple error form of:
//   name: "StatusCode#", where # is the status code e.g. 404.
//   message: Concatenation of the status text with response text
//     e.g. "NOT FOUND: Reservable not found"
//   original: The original error.
export const ConvertXMLRequestError = (err) => {
  // We have an error as dictated as an API response from the QReserve
  // backend.
  if (err.response &&
    err.response.data &&
    err.response.data.errors &&
    err.response.data.errors.length > 0) {
    const msg = err.response.statusText
      .concat(': ')
      .concat(err.response.data.errors.join(', '));

    const convErr = Error(msg);
    convErr.name = `StatusCode${err.response.status}`;
    convErr.original = err;
    convErr.errorMessage = err.response.data.errors.join(', ');
    return convErr;
  }

  // The error does not reflect an API response and is probably a more
  // general error relating to a failing of the server. Just use the
  // status code and status text.
  let msg = 'Error communicating with QReserve. Please try again in a moment.';
  let name = 'ServerError';
  if (err.response &&
    err.response.statusText) {
    msg = err.response.statusText;
  }
  if (err.response &&
    err.response.status) {
    name = `StatusCode${err.response.status}`;
  }

  const convErr = Error(msg);
  convErr.name = name;
  convErr.original = err;
  convErr.dump = () => Object({ name, original: err });
  return convErr;
};
